export const PAYMENT_METHOD_ERRORS = {
    BILLING_DETAILS_NEEDED: 'You are required to provide billing details prior to changing your payment method.',
};
